
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.053 16.488l1.808 1.854 6.389-6.551-6.389-6.55-1.808 1.853 3.303 3.387H0v2.62h12.356l-3.303 3.387zM20.444 0H2.556C1.144 0 0 1.173 0 2.62v5.24h2.556V2.62h17.888v18.342H2.556v-5.24H0v5.24c0 1.448 1.144 2.62 2.556 2.62h17.888c1.412 0 2.556-1.172 2.556-2.62V2.62C23 1.173 21.856 0 20.444 0z","fill":"#007185"}})])
          )
        }
      }
    